export default ({ COLORS }) => ({
  remove: {
    color: COLORS.RED.NORMAL
  }
})
